<div class="card item-table wartungsItemWrapper">
  <div class="card-header np clr-row nxm clr-align-items-baseline">
    <div class="clr-col-auto margin-12-t margin-12-l nxp">
      {{
        'Wartungs' +
          (mode() == 'personal' ? 'personal'
          : mode() == 'art' ? 'arten'
          : 'arbeiten') | mrTranslate
      }}
    </div>
    <div class="clr-col">
    <form
      id="item-form-{{ mode() }}"
      clrForm
      (ngSubmit)="saveIfValid()"
      class="flex-1-1-auto width100 d-f gap-2 clr-align-items-center no-margin">
      <clr-input-container class="flex-1-1-auto">
        <label hidden></label>
        <input
          clrInput
          type="text"
          name="Bezeichnung"
          class="mw-100-p w-100-p"
          [autofocus]="!!insertItem()"
          ngModel
          required
          [disabled]="!(insertItem() || selectedItem)" />
      </clr-input-container>
      @if (mode() == 'art') {
        <button type="button" class="btn btn-icon btn-outline btn-sm" (click)="setAutoHeaders()">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="lightbulb" />
            <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
              :: = {{ 'Header' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>
        <clr-select-container>
          <label>{{ 'Typ' | mrTranslate }}</label>
          <select clrSelect name="Typ" ngModel [disabled]="!(insertItem() || selectedItem)">
            <option [ngValue]="0">0 - {{ 'Header' | mrTranslate }}</option>
            <option [ngValue]="1">1 - {{ 'Prüfung' | mrTranslate }}</option>
            <option [ngValue]="2">2 - {{ 'Messwert' | mrTranslate }}</option>
          </select>
        </clr-select-container>
      }
    </form>
  </div>
  </div>
  <div class="card-block nyp d-f" #gridContainer>
    @if (table()?.columns) {
      <clr-datagrid
        #wItemGrid
        class="datagrid-compact h-100 w-100-p"
        [clrDgItemsIdentityFn]="row => row?.ID"
        [clrDgSelectionType]="'single'"
        [clrDgSelected]="[selectedItem]"
        (clrDgSelectedChange)="selectedItem = $event[0]"
        [clrDgRowSelection]="true">
        @for (column of table().columns; track column.id) {
          <clr-dg-column [clrDgField]="column.id" style="max-width: 50%">
            <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['bildlist'] }">
              {{ column.id | titlecase | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }
        <clr-dg-placeholder [class.hidePlaceholder]="isLoading()">
          @if (isLoading()) {
            <clr-spinner class="centred" />
          }
        </clr-dg-placeholder>
        <clr-dg-row
          *clrDgItems="let row of table().rows"
          [clrDgItem]="row"
          id="i-{{ row.ID }}"
          [class.headerRow]="row.Typ == 0">
          @for (cell of table().columns; track cell.id) {
            <clr-dg-cell class="name-cell" style="max-width: 50%">
              {{ row[cell.id] | tablePrettyPrint }}
            </clr-dg-cell>
          }
        </clr-dg-row>
        <clr-dg-footer>{{ table().rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    } @else {
      <clr-spinner class="centred" />
    }
  </div>
  <div class="card-footer">
    <div class="btn-group btn-primary btn-icon margin-0-t">
      <button
        class="btn btn-icon margin-12-l"
        [title]="'Speichern' | mrTranslate"
        type="submit"
        [attr.form]="'item-form-' + mode()"
        [disabled]="!(insertItem() || selectedItem)">
        <cds-icon shape="floppy" />
      </button>
      <button
        class="btn btn-icon btn-danger"
        [title]="'Löschen' | mrTranslate"
        (click)="deleteItem()"
        [disabled]="!selectedItem">
        <cds-icon shape="times" />
      </button>
      <button
        class="btn btn-icon btn-success"
        [title]="'Neu' | mrTranslate"
        (click)="addItem()"
        [disabled]="insertItem()">
        <cds-icon shape="file" />
      </button>
    </div>
    @if (withHelper()) {
      <button
        class="btn btn-icon"
        style="margin-left: auto"
        [title]="'Beschreibung' | mrTranslate"
        (click)="isHelperModalOpen.set(true)"
        [disabled]="!selectedItem">
        <cds-icon shape="help" />
      </button>
    }
  </div>
</div>

@if (withHelper()) {
  <app-hilfe-beschreibung-modal
    [(isModalOpen)]="isHelperModalOpen"
    [table]="'KWAART'"
    [id]="selectedItem?.ID"
    (onSave)="saveHelper($event)" />
}
